import type { ToeicArtifactType } from "@memorang/types";
import {
	ARTIFACT_LAYOUT,
	type ArtifactLayoutConfig,
	ITEM_TYPE_LAYOUT,
} from "@memorang/ui/components/StudySession/SessionContent/item-types/toeic-layout-config";
export type {
	LayoutConfig,
	Slot,
} from "@memorang/ui/components/StudySession/SessionContent/item-types/toeic-layout-config";

const isToeicArtifactType = (value: string): value is ToeicArtifactType =>
	value in ARTIFACT_LAYOUT;

const isItemTypeWithLayout = (
	value: string,
): value is keyof typeof ITEM_TYPE_LAYOUT => value in ITEM_TYPE_LAYOUT;

export function resolveLayoutConfig(item: {
	metadata?: { type?: string; toeic_artifact_type?: string };
	stimulusMetadata?: { toeic_artifact_type?: string };
}) {
	const itemType = item.metadata?.type;
	const artifactType = item.stimulusMetadata?.toeic_artifact_type;

	const artifactConfig: ArtifactLayoutConfig | undefined =
		artifactType && isToeicArtifactType(artifactType)
			? ARTIFACT_LAYOUT[artifactType]
			: undefined;
	const itemTypeConfig =
		itemType && isItemTypeWithLayout(itemType)
			? ITEM_TYPE_LAYOUT[itemType]
			: undefined;

	const right = artifactConfig?.right ?? itemTypeConfig?.right;
	const stacked = artifactConfig?.stacked ?? itemTypeConfig?.stacked;

	if (!(right && stacked)) {
		return undefined;
	}

	return {
		left: artifactConfig?.left ?? [],
		right,
		stacked,
	};
}
